// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-radio-button ~ .mat-radio-button {
    margin-left: 16px;
}



.civil-id-photos > div,
.rc-book-photos > div{
  margin-bottom: 20px;
}

.purchase-detail .questions{
  margin-top: 20px;
}
.purchase-detail .questions mat-label{
  font-size: 12px;
}

.mat-form-field{
  width: 100%;
}

form small.error{
  position: relative;
  top: -24px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInB1cmNoYXNlLWRldGFpbC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksaUJBQWlCO0FBQ3JCOzs7O0FBSUE7O0VBRUUsbUJBQW1CO0FBQ3JCOztBQUVBO0VBQ0UsZ0JBQWdCO0FBQ2xCO0FBQ0E7RUFDRSxlQUFlO0FBQ2pCOztBQUVBO0VBQ0UsV0FBVztBQUNiOztBQUVBO0VBQ0Usa0JBQWtCO0VBQ2xCLFVBQVU7QUFDWiIsImZpbGUiOiJwdXJjaGFzZS1kZXRhaWwuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5tYXQtcmFkaW8tYnV0dG9uIH4gLm1hdC1yYWRpby1idXR0b24ge1xuICAgIG1hcmdpbi1sZWZ0OiAxNnB4O1xufVxuXG5cblxuLmNpdmlsLWlkLXBob3RvcyA+IGRpdixcbi5yYy1ib29rLXBob3RvcyA+IGRpdntcbiAgbWFyZ2luLWJvdHRvbTogMjBweDtcbn1cblxuLnB1cmNoYXNlLWRldGFpbCAucXVlc3Rpb25ze1xuICBtYXJnaW4tdG9wOiAyMHB4O1xufVxuLnB1cmNoYXNlLWRldGFpbCAucXVlc3Rpb25zIG1hdC1sYWJlbHtcbiAgZm9udC1zaXplOiAxMnB4O1xufVxuXG4ubWF0LWZvcm0tZmllbGR7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG5mb3JtIHNtYWxsLmVycm9ye1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIHRvcDogLTI0cHg7XG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/secure/purchase-detail/purchase-detail.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;;;AAIA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA,o6BAAo6B","sourcesContent":[".mat-radio-button ~ .mat-radio-button {\n    margin-left: 16px;\n}\n\n\n\n.civil-id-photos > div,\n.rc-book-photos > div{\n  margin-bottom: 20px;\n}\n\n.purchase-detail .questions{\n  margin-top: 20px;\n}\n.purchase-detail .questions mat-label{\n  font-size: 12px;\n}\n\n.mat-form-field{\n  width: 100%;\n}\n\nform small.error{\n  position: relative;\n  top: -24px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
